export const TIER_TO_PATHOGENICITY = {
  1: "Tier I",
  2: "Tier II",
  3: "Tier III",
  4: "TIer IV",
};
